import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=531cdfbe&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=531cdfbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531cdfbe",
  null
  
)

export default component.exports